import { createContext, useContext } from 'react';

export const NotificationContext = createContext<{ unreadCount: number | null; refreshCount: () => Promise<void> } | null>(null);

export const useNotifications = () => {
  const context = useContext(NotificationContext);
  if (!context) throw new Error('NotificationProvider is required');
  return context;
};
